import React from "react";
import Header from "./Header";
import HeroSection from "./HeroSection";
import FeaturesSection from "./FeaturesSection";
import HowItWorksSection from "./HowItWorksSection";
import BenefitsSection from "./BenefitsSection";
import TestimonialsSection from "./TestimonialsSection";
import CTASection from "./CTASection";
import PricingSection from "./PricingSection";
import TrustBar from "./TrustBar";
import LeadCaptureSection from "./LeadCaptureSection";
import Footer from "./Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-orange-50 to-pink-50">
      <Header />
      <HeroSection />
      
      <FeaturesSection />
      <HowItWorksSection />
      <BenefitsSection />
      {/*<TestimonialsSection />
      <CTASection />*/}
      <PricingSection />
      <LeadCaptureSection />
      <TrustBar />
      <Footer />
    </div>
  );
};

export default HomePage;